<script lang="ts">
  /**
   * Ce que le Veredium a greffé, et ce qu'il réclame en retour.
   *
   * Le livre imprime chaque Tribut dans une colonne à part, sur trois pages
   * différentes selon qu'il s'agit d'une Prothèse, d'une Amélioration ou d'une
   * Main de Dieu : un Technodiacre qui en cumule trois n'a nulle part le compte
   * de ce qu'il doit. Ce panneau est cet endroit-là.
   */
  import { prouesse as lireLaProuesse, type PersonnageEnregistre } from '../../../rules'

  let {
    personnage,
    basculerGreffe,
  }: {
    personnage: PersonnageEnregistre
    /** Greffe, ou retire, une pièce de Prouesse. */
    basculerGreffe: (greffe: string) => void
  } = $props()

  const veredium = $derived(lireLaProuesse(personnage))
  let greffer = $state(false)

  const GENRES: Record<string, string> = {
    prothese: 'Prothèse',
    amelioration_de_prothese: 'Amélioration de Prothèse',
    amelioration_d_equipement: "Amélioration d'équipement",
  }
</script>

<div class="cartouche">
  <div class="bandeau">
    Prouesse
    {#if greffer}
      <button type="button" class="refermer" onclick={() => (greffer = false)}>Refermer</button>
    {/if}
  </div>
  <div class="corps">
    {#if veredium.tributs.length > 0}
      <p class="regle">
        Une greffe donne, et fait payer. Voici ce que vous devez — le livre
        l'imprime sur trois pages différentes, jamais d'un seul tenant.
      </p>
      <ul class="achats larges">
        {#each veredium.tributs as t (t.source)}
          <li class="tribut">
            <span class="nom">
              {t.source}
              {#each t.dit as d (d)}
                <span class="exigence">{d}</span>
              {/each}
            </span>
            <span class="quand">
              {t.declencheur ?? 'permanent — il pèse sur chaque jet concerné'}
            </span>
          </li>
        {/each}
      </ul>
    {/if}

    {#each veredium.greffes as g (g.id)}
      <section class="greffe">
        <h3>
          {g.nom}
          <span class="voie">{GENRES[g.genre] ?? g.genre}</span>
          <button type="button" class="lien" onclick={() => basculerGreffe(g.id)}>
            Retirer
          </button>
        </h3>
        {#each g.donne as d (d)}
          <span class="detail">{d}</span>
        {/each}
      </section>
    {/each}

    {#if !greffer}
      {#if veredium.greffes.length === 0}
        <p class="chapo">
          Rien de greffé. Le Veredium remplace un membre, améliore une arme ou
          une armure — et chaque pièce se paie d'un Tribut.
        </p>
      {/if}
      <button type="button" class="lien" onclick={() => (greffer = true)}>
        Greffer une pièce
      </button>
    {:else}
      <p class="regle">
        Le prix ne se décompte pas : le livre le demande en Points d'Influence,
        en Livres ou en fabrication selon la pièce, et c'est la table qui
        tranche.
      </p>
      <ul class="achats larges">
        {#each veredium.disponibles as g (g.id)}
          <li>
            <span class="nom">
              {g.nom}
              <span class="voie">{GENRES[g.genre] ?? g.genre}</span>
              {#if g.porte_sur}<span class="exigence">sur : {g.porte_sur}</span>{/if}
              {#each g.donne as d (d)}
                <span class="exigence">{d}</span>
              {/each}
              {#if g.tribut}
                <span class="manque">
                  Tribut : {g.tribut.dit.join(' · ')}
                  {#if g.tribut.declencheur}({g.tribut.declencheur}){/if}
                </span>
              {/if}
            </span>
            <span class="chiffres data">
              {#if g.prix_pi !== null}{g.prix_pi} PI{/if}
              {#if g.prix_livres !== null}{g.prix_livres} £{/if}
            </span>
            <button type="button" class="pilule" onclick={() => basculerGreffe(g.id)}>
              Greffer
            </button>
          </li>
        {/each}
      </ul>
    {/if}
  </div>
</div>

<style>
  /* Une greffe portée : son nom, puis ce qu'elle change. */
  .greffe {
    display: grid;
    gap: 2px;
    margin-bottom: var(--pas);
  }
  .greffe h3 {
    margin: 0;
    font-family: var(--titre);
    font-size: 0.9rem;
    display: flex;
    align-items: baseline;
    gap: var(--pas);
  }
  /* Ce qu'on doit : le déclencheur à droite, parce que c'est lui qui dit quand
     la note tombe. */
  .tribut .quand {
    font-size: 0.72rem;
    color: var(--pale);
    max-width: 28ch;
    text-align: right;
  }
  .cartouche {
    margin-bottom: calc(var(--pas) * 3);
  }
  .cartouche .corps {
    padding: calc(var(--pas) * 3);
    gap: calc(var(--pas) * 3);
  }
</style>
